import { useArrowNavigationGroup } from '@fluentui/react-components';
export const useChatMoverAttribute_unstable = ()=>// eslint-disable-next-line @typescript-eslint/naming-convention
    useArrowNavigationGroup({
        axis: 'vertical',
        unstable_hasDefault: true
    });

//# sourceMappingURL=useChatMoverAttribute.js.map